<template>
  <div class="jr-mx-15">
    <div class="jr-text-left">
      <div class="jr-font-base jr-text-sm">
        <p>選択したエリア来訪者数を100%としたときの施設カテゴリごとの来訪者数の構成比をランキングで表示しています。</p>
        <div class="jr-pt-4">
          <p>集計は「日のべ人数」です。</p>
          <p>
            <span class="jr-pr-2.5">※</span>
            <span>同一人物が2日間来訪した場合は2とカウント</span>
          </p>
          <p>
            <span class="jr-pr-2.5">※</span>
            <span>同一人物が同日に複数カテゴリを訪問した場合はそれぞれの施設で<br>カウント。</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
